module.exports = __webpack_public_path__ + "resources/images/money_hand-0a95862ed3a2895c04a5d71ee46320a6-cache.jpg";